// Mock data for BLACK AXE landing page (Actor: SOORI version)
// Images referenced from the original public asset CDN for visual parity.

export const HERO = {
  starring: "SOORI",
  inAndAs: "IN AND AS",
  title: "BLACK AXE",
  director: "WRITTEN AND DIRECTED BY ANL ARASU",
  tagline: "\u201CHe survived the bullet. Now the bullet is the weapon.\u201D",
  description:
    "A drifting yacht. Twenty bodies. One man kneeling in the dark with a bullet in his head and no memory of why. A new Tamil thriller — forged in salt, gold, and gunmetal.",
  status: "COMING SOON",
  poster: "/images/shared/poster-soori.jpg",
  posterMeta: "OFFICIAL POSTER \u00B7 V1",
  posterTag: "FIRST LOOK",
};

export const LOGLINE = {
  chapter: "CH 00B",
  label: "LOGLINE",
  heading: "LOGLINE",
  body:
    "\u201CA man with no name and a bullet lodged in his skull washes ashore in Sri Lanka — and every blow to his head awakens a violence even he doesn\u2019t understand. To learn who he is, he must destroy the empire that tried to erase him.\u201D",
  footer: "BLACK AXE \u00B7 A TAMIL NOIR FEATURE",
};

export const SYNOPSIS = {
  chapter: "CH 00C",
  label: "SYNOPSIS",
  heading: "SYNOPSIS",
  paragraphs: [
    "In the dead of night, somewhere off the Sri Lankan coast, a luxury yacht drifts in silence. Inside lies a massacre — twenty bodies, petrol-soaked, a man kneeling among the dead with tears and blood running down his face. A gunshot. A cigarette flicked from a departing boat. The yacht erupts into a fireball, and one man falls into the black water beneath the flames.",
    "He survives — barely. An old fisherman pulls him from the sea and treats his wound, but cannot remove the bullet lodged in his skull. When local police murder his rescuer, a blow to the back of his head awakens something dormant: the bullet, pressing against the part of his brain that holds violence in check, switches it off. What emerges is not a man fighting back — it is a man with no brakes.",
    "Fleeing to Rameswaram with the fisherman\u2019s granddaughter, captured as a refugee, his second eruption is caught on camera — and suddenly every gun on the coast is pointed at a man with no name, no identity, and no memory of the massacre he walked away from.",
    "The trail leads to Thoothukudi, and to the sister of Sagayam — a man who died on that yacht. She believes Pandi killed her brother. He needs to know if she\u2019s right. Her story reveals a friendship forged in prison, a smuggling job for a shadow syndicate called BIG BORA, and an informer purge that ended in fire on the water.",
    "But the deepest truth lies further back. Pandi was never a prisoner. He was one of a hidden few — children raised inside prison walls and forged into undercover agents, deployed where no officer could go. His mission was to destroy the BIG BORA consignment. Instead, it destroyed him.",
    "Now, with a bullet in his head that makes him lethal and is slowly killing him, Pandi must dismantle the BIG BORA empire, find the man who pulled the trigger — and expose the most dangerous truth of all: the powerful cop who has been erasing undercover agents one by one, building BIG BORA\u2019s empire from inside the very system meant to destroy it.",
  ],
  pullquote: "\u201CHe survived the bullet. Now the bullet is the weapon.\u201D",
};

export const NIGHT = {
  chapter: "CH 01",
  label: "INT. LUXURY YACHT \u2014 NIGHT",
  heading: "THE NIGHT ON THE WATER",
  body:
    "A luxury yacht drifts in silence. Inside lies a massacre — twenty bodies, petrol-soaked, a man kneeling among the dead with tears and blood running down his face. A gunshot. A cigarette flicked from a departing boat. The yacht erupts into a fireball, and one man falls into the black water beneath the flames.",
  quote: "\u201CHe survives — barely.\u201D",
};

export const BULLET = {
  chapter: "CH 02",
  label: "INSIDE PANDI\u2019S SKULL",
  heading: "THE BULLET",
  body:
    "An old fisherman pulls him from the sea and treats his wound — but cannot remove the bullet lodged in his skull. When local police murder his rescuer, a blow to the back of his head awakens something dormant: the bullet, pressing against the part of his brain that holds violence in check, switches it off.",
  quote: "\u201CWhat emerges is not a man fighting back — it is a man with no brakes.\u201D",
  status: "LEFT TEMPLE \u2014 VIOLENCE INHIBITOR \u2014 OFFLINE",
};

export const PANDI = {
  chapter: "CH 03",
  label: "CHARACTER \u2014 LEAD",
  heading: "PANDI",
  body:
    "No name. No identity. No memory of the massacre he walked away from. Pandi moves like a man trying to remember how to feel grief, while every nerve in his body remembers how to kill. SOORI brings a coiled stillness and explosive physicality to a role designed to be career-defining.",
  meta: [
    { k: "PORTRAYED BY", v: "SOORI" },
    { k: "AGE", v: "40s" },
    { k: "ORIGIN", v: "UNKNOWN \u2014 RAISED INSIDE PRISON WALLS" },
    { k: "SKILL", v: "CLOSE-QUARTERS COMBAT, COUNTER-INTEL" },
  ],
  plates: [
    {
      img: "/images/pandi/pandi0.png",
      n: "PLATE 01",
      title: "INTERROGATION \u00B7 RED ROOM \u00B7 STARE",
    },
    {
      img: "/images/pandi/pandi1.png",
      n: "PLATE 02",
      title: "THE CAGE \u00B7 NO BRAKES \u00B7 NIGHT",
    },
    {
      img: "/images/pandi/pandi2.jpg",
      n: "PLATE 03",
      title: "THE STRIKE \u00B7 LOW ANGLE \u00B7 DAY",
    },
    {
      img: "/images/pandi/pandi3.jpg",
      n: "PLATE 04",
      title: "PROFILE \u00B7 GREEN STEEL \u00B7 QUIET",
    },
    {
      img: "/images/pandi/pandi4.jpg",
      n: "PLATE 05",
      title: "THE ROAR \u00B7 CORRIDOR \u00B7 BLOOD",
    },
    {
      img: "/images/pandi/pandi5.jpg",
      n: "PLATE 06",
      title: "MONSOON \u00B7 STILLNESS \u00B7 THE WEIGHT",
    },
  ],
};

export const REEL = {
  chapter: "CH 04",
  label: "CHARACTER REEL \u00B7 30 SECONDS",
  heading: "SOORI AS PANDI",
  body:
    "A 30-second introduction reel anchored on SOORI — the silence before the storm, the body that carries the bullet, the eyes that have forgotten who they were. Drop in the final cut here; the player below is ready for the master file.",
  cta: "Tap for Sound",
  meta: "REEL 01 \u00B7 CHARACTER INTRODUCTION",
  yearTag: "BLACK AXE \u00B7 2026",
};

export const FISHERMAN = {
  chapter: "CH 05",
  label: "EXT. RAMESWARAM \u2014 DAY",
  heading: "THE FISHERMAN & THE GIRL",
  body:
    "Fleeing the coast with the fisherman\u2019s granddaughter, Pandi is captured as a refugee. His second eruption is caught on camera — and suddenly every gun on the coast is pointed at a man with no name. The girl becomes his only anchor to the human he used to be.",
  quote:
    "\u201CA grandfather\u2019s last gift was the granddaughter who kept him alive.\u201D",
  plates: [
    {
      img: "https://blackxe.org/assets/moodboard/fish2.jpg",
      n: "PLATE 01",
      title: "THE COMPOUND \u00B7 DUSK \u00B7 WATCHTOWER",
    },
    {
      img: "https://blackxe.org/assets/moodboard/fish1.jpg",
      n: "PLATE 02",
      title: "INSIDE \u00B7 REFUGEES \u00B7 BLUE LIGHT",
    },
  ],
};

export const SAGAYAM = {
  chapter: "CH 06",
  label: "EXT. THOOTHUKUDI PORT \u2014 DUSK",
  heading: "SAGAYAM\u2019S SISTER",
  body:
    "The trail leads to the sister of Sagayam — one of the twenty who died on the yacht. She believes Pandi pulled the trigger. He needs to know if she is right. Her story reveals a friendship forged in prison, a smuggling job for a shadow syndicate called BIG BORA, and an informer purge that ended in fire on the water.",
  quote: "\u201CDid you kill my brother?\u201D",
};

export const HIDDEN = {
  chapter: "CH 07",
  label: "CLASSIFIED \u2014 BLACK FILE / PRISON STATE PROGRAM",
  heading: "THE HIDDEN FEW",
  body:
    "Pandi was never a prisoner. He was one of a hidden few — children raised inside prison walls and forged into undercover agents, deployed where no officer could go. His mission was to destroy the BIG BORA consignment. Instead, it destroyed him.",
  meta: [
    { k: "ORIGIN", v: "Born inside the system. Erased from it." },
    { k: "TRAINING", v: "No academy. No record. No exit." },
    { k: "COST", v: "Twenty agents on one yacht. One survivor." },
  ],
  plates: [
    {
      img: "https://blackxe.org/assets/moodboard/hidden1.jpg",
      n: "PLATE 01",
      title: "INDUCTION \u00B7 BEFORE THE HUNDRED",
    },
    {
      img: "/images/shared/behind-bars.png",
      n: "PLATE 02",
      title: "BEHIND THE BARS \u00B7 LISTENING",
    },
  ],
};

export const AKR = {
  chapter: "CH 08",
  label: "INT. BIG BORA FRONT OFFICES \u2014 MULTI-PORT",
  heading: "THE BIG BORA EMPIRE",
  body:
    "A shadow syndicate routed through fishing fleets, customs ledgers and burner phones — weapons, narcotics, and human cargo moving along the Tamil Nadu-Sri Lanka corridor. BIG BORA doesn\u2019t fear the state because BIG BORA has the state.",
  meta: [
    { k: "ROUTES", v: "Mannar \u2014 Rameswaram \u2014 Thoothukudi" },
    { k: "FRONTS", v: "Trawlers, scrap yards, sand mafia, casinos" },
    { k: "HIERARCHY", v: "5 captains, 1 ghost above them" },
    { k: "BODY COUNT", v: "20 in one night \u2014 and counting" },
  ],
};

export const POLICE = {
  chapter: "CH 08B",
  label: "EXT. NIGHT MARKET / INT. WAREHOUSE / POLICE COMMISSIONERATE \u2014 THE BADGE",
  heading: "THE POLICE \u00B7 THE MAN INSIDE THE SYSTEM",
  paragraphs: [
    "The uniform is the empire\u2019s sharpest mask. A khaki shirt and a star on the shoulder — a man the state trusts, a man the street fears. In the world of BLACK AXE the police are not the answer; they are the question. Every door BIG BORA opens, the badge opened first.",
    "The deepest truth lies further back: a powerful cop has been erasing undercover agents one by one, building BIG BORA\u2019s empire from inside the very system meant to destroy it. The man Pandi was meant to report to is the man who pulled the trigger.",
  ],
  plates: [
    {
      img: "https://blackxe.org/assets/moodboard/police2.jpg",
      n: "PLATE 01",
      title: "THE BADGE IN THE CROWD",
    },
    {
      img: "https://blackxe.org/assets/moodboard/police1.jpg",
      n: "PLATE 02",
      title: "THE THRONE \u00B7 TWO HOODS \u00B7 A GUN",
    },
  ],
  quote: "\u201CThe bullet didn\u2019t come from an enemy. It came from his own commanding officer.\u201D",
};

export const VISION = {
  chapter: "CH 10",
  label: "DIRECTOR\u2019S STATEMENT \u00B7 LOOK & FEEL",
  heading: "DIRECTOR\u2019S VISION",
  paragraphs: [
    "A myth told in gunmetal and gold. We treat the bullet as a god and Pandi as its unwilling prophet. The film breathes through the slow heat of southern Tamil ports — brass lamps, fish-oil light, rain on tin roofs — then erupts in operatic, intimate violence. We are not making a vigilante film. We are making the autopsy of one.",
    "A palette of rust, hammered gold, oxblood and salt-bleached emerald. Costumes weathered to the bone; sets built around the smell of diesel and dried fish. The emerald-glass skull — our only futuristic motif — lives inside Pandi\u2019s vision: a cool, otherworldly interruption in a film of brown, brass and blood.",
  ],
  meta: [
    { k: "TONE", v: "Mythic, intimate, brutal." },
    { k: "PALETTE", v: "Rust \u00B7 hammered gold \u00B7 oxblood \u00B7 salt-bleached emerald." },
    { k: "REFERENCES", v: "No Country for Old Men \u00B7 Sicario \u00B7 Old Boy \u00B7 Asuran" },
    { k: "CINEMATIC LANGUAGE", v: "Long lenses, available light, 35mm grain." },
  ],
  plates: [
    { img: "/images/shared/behind-bars.png", n: "PLATE 01", title: "BEHIND THE BARS \u00B7 BLOOD ON THE BROW" },
    { img: "https://blackxe.org/assets/moodboard/dv5.jpg", n: "PLATE 02", title: "THE CONSIGNMENT \u00B7 WEAPONS AT DOCK" },
    { img: "https://blackxe.org/assets/moodboard/dv4.jpg", n: "PLATE 03", title: "THE WALK \u00B7 BLACK SUIT \u00B7 ARMED MEN" },
    { img: "https://blackxe.org/assets/moodboard/dv3.jpg", n: "PLATE 04", title: "PORT-CITY DUSK \u00B7 THE CONGREGATION" },
    { img: "https://blackxe.org/assets/moodboard/dv2.jpg", n: "PLATE 05", title: "GOLDEN HOUR \u00B7 GUNS IN SILHOUETTE" },
    { img: "https://blackxe.org/assets/moodboard/dv1.jpg", n: "PLATE 06", title: "THE BRAWL \u00B7 SHIPYARD \u00B7 CHAOS" },
  ],
};

export const PEOPLE = {
  chapter: "CH 12",
  label: "PEOPLE \u00B7 MOODBOARD",
  heading: "PEOPLE OF BLACK AXE WORLD",
  body:
    "The faces that carry the weight of this world — the fisherman who pulls a stranger from the sea, the granddaughter who keeps a dying man human, the bodies left in the wake of the BIG BORA machine, the crowds that hide Pandi when no one else can. Every shot tells you who lives here, who survives, and at what cost.",
  plates: [
    { img: "https://blackxe.org/assets/moodboard/p5.jpg", n: "PLATE 01", title: "THE FISHERMAN \u00B7 DAWN NETS" },
    { img: "https://blackxe.org/assets/moodboard/p4.jpg", n: "PLATE 02", title: "ELDER \u00B7 SEA \u00B7 WEATHERED" },
    { img: "https://blackxe.org/assets/moodboard/p3.jpg", n: "PLATE 03", title: "TWENTY BODIES \u00B7 YACHT NIGHT" },
    { img: "https://blackxe.org/assets/moodboard/p2.jpg", n: "PLATE 04", title: "STREET \u00B7 CROWD \u00B7 LANTERNS" },
    { img: "https://blackxe.org/assets/moodboard/p1.jpg", n: "PLATE 05", title: "PANDI \u00B7 IN THE CROWD" },
  ],
};

export const WORLD = {
  chapter: "CH 12B",
  label: "WORLD \u00B7 MOODBOARD",
  heading: "THE BLACK AXE WORLD",
  body:
    "The places that hold the story — a luxury yacht turned coffin, a slick of burning petrol on dark water, a man sinking with a bullet in his head, and the shipyards where BIG BORA moves whatever the empire pays for. The world of BLACK AXE is salt, steel, and fire.",
  plates: [
    { img: "https://blackxe.org/assets/moodboard/world1.jpg", n: "PLATE 01", title: "THE YACHT \u00B7 ARMED \u00B7 BLUE HOUR" },
    { img: "https://blackxe.org/assets/moodboard/world2.jpg", n: "PLATE 02", title: "THE FIREBALL \u00B7 YACHT IGNITION" },
    { img: "https://blackxe.org/assets/moodboard/world3.jpg", n: "PLATE 03", title: "THE SLICK \u00B7 BURNING WATER" },
    { img: "https://blackxe.org/assets/moodboard/world4.png", n: "PLATE 04", title: "INTO THE BLACK \u00B7 ONE SURVIVOR" },
    { img: "https://blackxe.org/assets/moodboard/world5.jpg", n: "PLATE 05", title: "BIG BORA DOCKS \u00B7 STEEL \u00B7 DIESEL" },
  ],
};

export const MARKET = {
  chapter: "CH 13",
  label: "MARKET & AUDIENCE",
  heading: "MARKET & AUDIENCE",
  body:
    "A theatrical-first release targeting the pan-Indian noir-thriller audience that propelled KGF, Vikram and Jailer to massive openings. Built for a 4-language simultaneous release with strong OTT and international festival tail.",
  meta: [
    { k: "PRIMARY MARKET", v: "Tamil Nadu, Karnataka, Kerala, Andhra/Telangana" },
    { k: "SECONDARY MARKET", v: "Hindi belt + diaspora (US, UK, Gulf, Malaysia)" },
    { k: "COMPARABLES", v: "Vikram \u00B7 Jailer \u00B7 Asuran \u00B7 Maharaja" },
    { k: "AUDIENCE", v: "18\u201349 \u00B7 action-thriller \u00B7 prestige-noir fans" },
    { k: "OTT WINDOW", v: "Tier-1 streamer post 56-day theatrical" },
  ],
};

export const PRODUCTION = {
  chapter: "CH 14",
  label: "PRODUCTION",
  heading: "PRODUCTION",
  body:
    "A 95-day production schedule across Rameswaram, Thoothukudi, Mannar (Sri Lanka) and Chennai. Anchored by a stunt and action design team with credits across major Tamil and Telugu features.",
  meta: [
    { k: "STATUS", v: "Pre-production" },
    { k: "SHOOT WINDOW", v: "95 days \u00B7 Q1\u2013Q2 2026" },
    { k: "LANGUAGES", v: "Tamil (original) \u00B7 Telugu \u00B7 Hindi \u00B7 Malayalam" },
    { k: "BUDGET TIER", v: "Mid-to-high tier theatrical" },
    { k: "TARGET RELEASE", v: "Q4 2026 \u2014 festive theatrical window" },
  ],
};

export const DIRECTOR = {
  chapter: "CH 15",
  label: "DIRECTED BY",
  heading: "ANL ARASU",
  img: "https://blackxe.org/assets/director/anl-arasu.jpg",
  role: "ACTION DIRECTOR \u00B7 CHOREOGRAPHER \u00B7 DIRECTOR",
  meta: [
    { k: "REEL", v: "200+ FILMS" },
    { k: "LANGUAGES", v: "5 \u00B7 PAN-INDIA" },
    { k: "STATUS", v: "DIRECTOR \u00B7 CONFIRMED" },
  ],
  paragraphs: [
    "Anl Arasu is a multi-award-winning Indian action director and choreographer with over two decades of expertise in high-octane cinema.",
    "Renowned for his gritty and realistic fight choreography, he has sculpted the action for blockbusters like Jawan, Sultan, and the Singam series.",
    "Having worked across more than 200 films in multiple languages, he is now bringing his signature high-stakes vision to the director\u2019s chair.",
    "His mastery of cinematic violence and emotional stakes makes him the perfect architect for the world of BLACK AXE.",
  ],
  films: [
    { t: "JAWAN", r: "ACTION DESIGN" },
    { t: "SULTAN", r: "ACTION DESIGN" },
    { t: "SINGAM SERIES", r: "ACTION DESIGN" },
    { t: "ROWDY RATHORE", r: "ACTION DESIGN" },
    { t: "KATHTHI", r: "ACTION DESIGN" },
    { t: "I", r: "ACTION DESIGN" },
  ],
  footer: "BLACK AXE \u00B7 WESTERN LINE \u00B7 MUMBAI \u00B7 2026",
};

export const CONTACT = {
  chapter: "INVESTOR & PRODUCTION INQUIRIES",
  heading: "TAKE THE SHOT",
  body:
    "A first-look slot is open to a single co-production partner and a single international distribution partner. Submit your inquiry below — we will respond within 72 hours with the full deck, budget breakdown and key crew package.",
  note: "We will respond within 72 hours with the full deck and budget.",
};
